module.exports = __webpack_public_path__ + "img/1.6bfb3f52.png";